import React, { useEffect, useState } from "react";
import { Container } from "@mui/material";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Helmet } from "react-helmet-async";
import adminApi from "./adminApi";

// ----------------- Styled Components -----------------
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

// ----------------- Main Component -----------------
const ContactUsData = () => {
  const [rows, setRows] = useState([]);

  // ⭐ Fetch Contacts — SAME PATTERN AS YOUR BLOG API
  const fetchContacts = async () => {
    try {
      const res = await adminApi.get("/admin/contacts");
      setRows(res.data.data || []);
    } catch (error) {
      console.error("Error fetching contacts:", error);
    }
  };

  useEffect(() => {
    fetchContacts();
  }, []);

  return (
      <>

        <Helmet>
          <link rel="canonical" href="https://www.hcfinvest.com/adminContactUsData" />
        </Helmet>

      <Container
      maxWidth={false}
      disableGutters
      sx={{ backgroundColor: "#fff", pt: 3 , maxWidth:'1200px' }}
    >
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Name</StyledTableCell>
              <StyledTableCell>Email</StyledTableCell>
              <StyledTableCell>Subject</StyledTableCell>
              <StyledTableCell>Message</StyledTableCell>
              <StyledTableCell>Status</StyledTableCell>
              <StyledTableCell align="right">Received</StyledTableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.length === 0 ? (
              <TableRow>
                <StyledTableCell colSpan={6} align="center">
                  No contact records found.
                </StyledTableCell>
              </TableRow>
            ) : (
              rows.map((row) => (
                <StyledTableRow key={row._id}>
                  <StyledTableCell>{row.name}</StyledTableCell>
                  <StyledTableCell>{row.email}</StyledTableCell>
                  <StyledTableCell>{row.subject}</StyledTableCell>
                  <StyledTableCell>{row.message}</StyledTableCell>
                  <StyledTableCell>{row.status}</StyledTableCell>
                  <StyledTableCell align="right">
                    {new Date(row.createdAt).toLocaleString()}
                  </StyledTableCell>
                </StyledTableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
      </>
  );
};

export default ContactUsData;
